module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jimmy Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Carolyn Chisam")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Geraldine Eppley")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Darrell and Tonya Farmer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Natasha Hipp")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gavin Howard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ralph Howard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jimmy and Jagina Howard King")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hilda Howard Morrow")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Charlie Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Richard H. Wood")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Alan Zordan")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A special word of thanks to Candace Rathbone for her tireless work and expert assistance in preparing the manuscript for publication.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0aab5a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0